import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import DirectionsIcon from "@mui/icons-material/Directions";
import { Button, Typography } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

export default function CustomizedInputBase({ searchText, setSearchText }) {
  return (
    <Paper
      component="form"
      elevation={2}
      sx={{
        p: "2px 4px",
        display: "flex",
        alignItems: "center",
        width: 600,
        borderRadius: 20,
        bgcolor: "background.default",
      }}
    >
      <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
        <SearchIcon />
      </IconButton>

      <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
      <InputBase
        sx={{ ml: 1, flex: 1 }}
        placeholder="Search Admin Details..."
        inputProps={{ "aria-label": "search google maps" }}
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
      />
      <IconButton
        color="primary"
        onClick={() => setSearchText("")}
        sx={{
          visibility: searchText ? "visible" : "hidden",
          fontSize: "14px",
          color: "gray",
          fontWeight: 400,
        }}
        aria-label="directions"
      >
        <CloseRoundedIcon />
      </IconButton>
    </Paper>
  );
}
